enum TCampaignDuration {
  twelveMonths = "twelveMonths",
  sixMonths = "sixMonths",
  threeMonths = "threeMonths",
}

type TTrackingCampaign = {
  id: number;
  period_start: string;
  period_end: string;
  employees: number;
  turnover: number;
  score: {
    id: number;
    is_external: boolean;
  };
  finished: boolean;
  review_id: number;
};

type TTrackingCampaignDetails = {
  id: number;
  period_start: string;
  period_end: string;
  employees: number;
  turnover: number;
  score: {
    id: number;
    is_external: boolean;
    external_provider: string;
  };
  review: {
    id: number;
    finished: boolean;
  };
  created_at: string;
  updated_at: string;
};

export type { TTrackingCampaign, TTrackingCampaignDetails };
export { TCampaignDuration };
